export default "__VITE_ASSET__CVCUzauo__"